import cx from "classnames";

import NestedTab from "./NestedTab";
import RegularTab from "./RegularTab";
import { isNestedOption, Option, BaseOptionValue } from "./types";
import "./Tabs.scss";

type Props<V extends BaseOptionValue> = {
  options: Option<V>[];
  selectedValue: V | undefined;
  onChange?: (value: V) => void;
  size?: "large" | "medium" | "small";
  type?: "inline" | "block";
  className?: string;
  regularOptionClassname?: string;
  qa?: string;
  variant?: "default" | "secondary" | "outlined" | "ghost" | "filled";
};

export default function Tabs<V extends string | number>({
  options,
  selectedValue,
  onChange,
  size = "medium",
  type = "block",
  className,
  regularOptionClassname,
  qa,
  variant = "default",
}: Props<V>) {
  return (
    <div data-qa={qa} className={cx("Tab", `Tab__${type}`, `Tab__${size}`, className, variant)}>
      {options.map((opt) =>
        isNestedOption(opt) ? (
          <NestedTab key={opt.label?.toString()} option={opt} selectedValue={selectedValue} onOptionClick={onChange} />
        ) : (
          <RegularTab
            key={opt.value}
            option={opt}
            selectedValue={selectedValue}
            onOptionClick={onChange}
            regularOptionClassname={regularOptionClassname}
          />
        )
      )}
    </div>
  );
}
